import * as React from "react";
import { useMemo } from "react";
import BulkActionsDropdown from "components/common/EntityDataTable/BulkActionsDropdown";
import useEventBulkActions from "components/events/events/hooks/useEventBulkActions";
import useSecurityEventBulkActions from "security-app/components/SecurityEvents/Alerts/useSecurityEventBulkActions";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import useReplayBulkAction from "components/events/events/hooks/useReplayBulkAction";
const BulkActions = ({ selectedEntitiesData }) => {
  const currentUser = useCurrentUser();
  const selectedEvents = useMemo(() => Object.values(selectedEntitiesData), [selectedEntitiesData]);
  const { actions, pluggableActionModals } = useEventBulkActions(selectedEvents);
  const { actions: securityEventActions, pluggableActionModals: securityEventModals } = useSecurityEventBulkActions(selectedEvents);
  const replayableEvents = selectedEvents.filter(
    (event) => !!event.replay_info && isPermitted(currentUser == null ? void 0 : currentUser.permissions, `eventdefinitions:read:${event.id}`)
  );
  const onReplaySearchClick = useReplayBulkAction(replayableEvents);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(BulkActionsDropdown, null, replayableEvents.length > 0 && /* @__PURE__ */ React.createElement(MenuItem, { onClick: onReplaySearchClick }, "Replay Search"), actions, securityEventActions), pluggableActionModals, securityEventModals);
};
export default BulkActions;
